export enum LivePayPaymentStatusEnum {
  RED = 1,
  YELLOW = 2,
  GREEN = 3,
}
